import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-azure-blob-storage-checklist',
  templateUrl: './help-azure-blob-storage-checklist.component.html'
})
export class HelpAzureBlobStorageChecklistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
